import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
    lang: {},
    language: 'en'
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    setDocumentTitle(`Privacy Policy`)
    let { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken
    })
    
  }

  componentDidMount() {
  }

  jump = () => {
    history.push(`/activity/lottery?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  jumpChild = () => {
    history.push(`/app/child_safety_policy_voca?uid=${this.state.uid}&accesstoken=${this.state.accesstoken}`)
  }

  render() {
    return (
      <div className="policy">
        
        Prompt Terms
        <br />
        The operation entity of "Voca". (hereinafter referred to as the "we") knows the importance of personal
        information to you, and will try our best to protect your personal information safety. We are committed to
        maintaining your trust to us, abide by the following principles, to protect your personal information: principle
        of right consistent with responsibility, the principle of purpose, principle of choosing agreed, principle of
        using the least, principle of ensuring security, principle of entity participation, transparency and so on. At
        the same time, we promise that we will take appropriate security measures to protect your personal information
        according to mature security solutions in the industry. In view of this, we have formulated this Privacy Policy
        (hereinafter referred to as "this Policy/Privacy Policy") and we remind you:
        <br />
        This Policy applies to "Voca" software and related services.
        <br />
        Before using the "Voca" software and related services, you must carefully read and understand this Policy, and
        use the relevant products or services after confirming your full understanding and consent. By using the "Voca"
        software and related services, you fully understand and agree to this Policy. If you have any questions,
        comments or suggestions regarding the content of this Policy, you can contact us through the various contact
        information provided by "Voca".
        <br />
        This Privacy Policy section will help you understand the following:
        <br />
        1. Personal Information we collect from you and its purposes
        <br />
        2. We may need to obtain your device permissions
        <br />
        3. How do we share your personal information
        <br />
        4. How do we protect your personal information
        <br />
        5. How do you manage your personal information
        <br />
        6. <span class="contact" onClick={this.jumpChild.bind(this)}>Child Safety Policy</span>
        <br />
        I. Personal Information we collect from you and its purposes
        <br />
        Personal Information refers to all kinds of information recorded by electronic or other means that can
        independently or in combination with other information to identify the identity of a specific natural person or
        reflect the activities of a specific natural person. We will collect and use your Personal Information for the
        following purposes:
        <br />
        (1) We will use the video shooting function to allow users to upload videos to moment.
        <br />
        This function is only for users to share their life. Chaite will not share the video content outside the app.
        Only when the user clicks pulish, will it be made public for other users to view.
        <br />
        (2) We have used a third-party service, ShareTrace, to track the installation sources of the app. The ShareTrace
        SDK will obtain the following information (device brand, device model, operating system version, device
        resolution, IP address, clipboard, etc.) for data statistics and analysis. At the same time, it will obtain
        process list information to ensure that it is only initialized in the main process to prevent unknown errors
        caused by multiple initializations. It will only be obtained after you agree to authorization.
        <br />
        Attached ShareTrace Privacy Policy https://www.sharetrace.com/Privacy.html (3)We will collect your mobile phone
        number, which will be used to create "Voca" account for you and provide you with relevant services;
        <br />
        (4) We will collect your gender and date of birth information for other users to better understand you and for
        us to provide you with services more suitable for your needs and to match you with users more suitable for you.
        <br />
        (5) According to specific permissions granted in the process of your installation and use of "Voca" software and
        related services, we will collect information on the equipment you use (e.g., equipment type, operation system
        version, equipment configuration, equipment identification, software and hardware information such as network
        information, equipment, environment, etc.), to provide you with search results as well as demonstrations that
        are more fit your needs, to understand product suitability and to identify the abnormal state of accounts.
        <br />
        (6) We will collect your web log information (the date and time of your use of App software and relevant
        services, etc.) to identify abnormal status of your account and meet the requirements of relevant laws and
        regulations.
        <br />
        (7) we may use or integrate your user information, equipment information and related web logs, in order to
        improve security in your use of our service, to protect your or other users’ or the public personal property
        safety of from harm and, to better prevent fishing website, fraud, the network vulnerability, computer viruses,
        network attacks, network intrusion and other risks. It can more accurately identify violation of laws and
        regulations or violation of "Voca" related agreement, and it is used for comprehensive judgment on your account
        risk, account validation, account examination, testing, to prevent security incidents, and to take necessary
        measures to record, analyze and dispose.
        <br />
        (8) We may keep your communication/call records and contents or your contact information when you contact us, so
        as to contact you or help you solve problems, or keep record of the solutions and results for relevant problems.
        <br />
        (9) We will collect the contents of Clipboard Data. We does not disclose the collection of Clipboard Data.We
        does not disclose the usage of collected Clipboard Data.
        <br />
        If we stop operating "Voca" software and related services, we will immediately stop collecting your personal
        information, and notify you of the stop of operation in the form of one-by-one service or announcement, and
        delete or anonymize the personal information we hold in accordance with relevant laws and regulations.
        <br />
        What Information We Collect
        <br />
        Information You Provide to Us
        <br />
        We collect information you provide to us directly when you use the Services. This includes:
        <br />
        <br />
        Content you submit: We collect the content you submit to the Services. This includes your posts, incident
        submissions and comments including saved drafts, photos and videos, your messages with other users (e.g., online
        comments), and your other communications with other users and with us. Your content may include text, links,
        images, gifs, audio, and videos.
        <br />
        <br />
        Videos: Without your consent, we would not submit videos for the use in shares.
        <br />
        We will need to obtain authorisation to access the video and camera on your mobile phone that is sharing your
        life. If you do not use the above service we will not access your video and camera.
        <br />
        You can withdraw your consent for us to access your mobile phone video and camera at any time.
        <br />
        II. We may need to obtain your device permissions
        <br />
        (a) we need to get the authorization of access to your mobile phone photo albums, to enable you to select a
        photo from the album of your phone as your account avatar. If you do not use the aforementioned service we
        provide, we will not visit your phone photo albums. You can cancel the authorization at any time for us to visit
        your mobile phone photo albums.
        <br />
        (2) we need to get the authorization of access to your mobile phone photo albums, to enable you to choose photo
        from your mobile phone album as content to post. If you do not use the aforementioned service we provide, we
        will not visit your phone photo albums. You can cancel the authorization at any time for us to access your
        mobile phone photo albums.
        <br />
        (3) we need to get the authorization of access to your mobile phone microphone, to enable you use your mobile
        phone microphone to record your voice and/or have voice chat. If you do not use the aforementioned service we
        provide, we will not visit your phone photo microphone. You can cancel the authorization at any time for us to
        access your mobile phone photo microphone.
        <br />
        (4) we need to get the authorization of access to your location, which is used to display your living city to
        other users and/or match the user for you and/or recommend content from users in the same place for you. If you
        do not use the aforementioned service we provide, we will not visit your location. You can cancel the
        authorization at any time for us to access your location.
        <br />
        (5) We need the authorization of your mobile phone notification so that we can push relevant service
        notifications to you. If you do not want to receive the aforementioned notifications, you may close our mobile
        phone notification access at any time.
        <br />
        (6) we need to get the authorization of access to your mobile phone video and camera, which is used to push
        moment for share your life. If you do not use the aforementioned service we provide, we will not visit your
        video and camera. You can cancel the authorization at any time for us to access your mobile phone video and
        camera.
        <br />
        III. How do we share and disclose your personal information
        <br />
        (1) Sharing
        <br />
        We will not share your Personal Information with any third party, but we will share your Personal Information
        with the third party designated by you if you choose to share it voluntarily or otherwise authorize us to share
        it.
        <br />
        (2) Transfer
        <br />
        We will not transfer your Personal Information to any company, organization or individual, except in the
        following circumstances:
        <br />
        1. Transfer with express consent: After obtaining your express consent, we will transfer your personal
        information to other parties.
        <br />
        2, When it comes to mergers, acquisitions or bankruptcy liquidation, or other situations involving mergers,
        acquisitions or bankruptcy liquidation, if personal information transfer is involved, we will request the new
        holder of you personal information, the company and the organization, continues to be bound by this policy,
        otherwise we will ask the company, organization or individual to obtain consent from you again.
        <br />
        IV. How do we protect your personal information
        <br />
        (1) We try our best to provide security measures for users' personal information, to prevent illegal use,
        unauthorized access, disclosure, leakage, damage and loss of users' personal information. We will use all
        possible security measures within a reasonable security level to ensure the information security. For example,
        we will use encryption technology (e.g., SSL), anonymization, encrypted storage and other means to protect your
        personal information; We will establish trusted protection mechanisms against malicious attacks on personal
        information; We will establish control mechanisms to access, abide by the principle of minimum access, and
        ensure that only authorized personnel will have access to personal information; We will carry out training
        courses on security and personal information protection to strengthen employees' understanding on personal
        information protection.
        <br />
        (2) We will take all reasonably practicable measures to avoid collection of irrelevant personal information.
        <br />
        If you find that your personal information, especially your account or password, has been compromised, please
        contact us immediately so that we can take appropriate measures according to your application.
        <br />
        Please note that you voluntarily share or even publicly share your information when using our services, which
        may involve your personal information or others' personal information. Please carefully consider whether to
        share or even publicly share such information when using our services.
        <br />
        V. How do you manage your personal information
        <br />
        You can access and manage your personal information in the following ways:
        <br />
        (I) Access your personal information
        <br />
        You have the right to access your personal information, except under the circumstances provided by laws and
        regulations. You can access your personal information by yourself in the following ways:
        <br />
        Account Information - If you wish to access or edit profile information in your account, such as avatar and
        nickname, you can do so by clicking My-Edit Profile.
        <br />
        If you cannot have access to the personal information through the above pathways, you may contact us at any time
        through "Feedback". We will respond to your request for access within 15 days.
        <br />
        (2) Correct or supplement your personal information
        <br />
        You have the right to request us to make corrections or supplements when you find that there are errors in the
        personal information that we process about you. You may apply for corrections or supplements in the manner set
        out in "(I) Access Your Personal Information" in this section.
        <br />
        (3) Delete your personal information
        <br />
        If you need to delete your user information, there are three ways to do so:
        <br />
        1.Send us feedback on the login page through the following path: Feedback button on the login page>Feedback.
        Once we receive feedback, we will contact you
        <br />
        2.Log in to your application and send us feedback through the following path: I>Feedback. Once we receive
        feedback, we will contact you
        <br />
        3.Log in to your application and complete it autonomously through the following path: Me>Settings>Delete Account
        <br />
        <br />
        You may request us to delete your personal information under the following circumstances:
        <br />
        1. If we deal with personal information in violation of laws and regulations;
        <br />
        2. If we collect and use your personal information without your express consent;
        <br />
        3. If we seriously violate the agreement with you in the dispose of our personal information;
        <br />
        4. If you no longer use our products or services
        <br />
        5. If we will no longer provide you with products or services permanently.
        <br />
        If we decide to respond to your removal request, we will do so in a timely manner.
        <br />
        <div onClick={this.jump.bind(this)}>
        When you delete information from our services, we may not delete the corresponding information from the backup
        system immediately, but we will delete this information when the backup is updated.
        </div>
       </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/privacypolicy_voca/index.js